import { createBasicSelector } from 'util/redux'
import { selectBooleanPreferenceByName } from './selectBooleanPreferenceByName'

export const selectCurrentUserPrefersAutoAdvanceOnSnoozed = createBasicSelector(
  state =>
    selectBooleanPreferenceByName(state, 'chat_auto_advance_on_snoozed', true)
)
